var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _class2, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { configure, runInAction } from "mobx";
import primitiveTrait from "../../lib/Traits/Decorators/primitiveTrait";
import objectTrait from "../../lib/Traits/Decorators/objectTrait";
import ModelTraits from "../../lib/Traits/ModelTraits";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import Terria from "../../lib/Models/Terria";
import createStratumInstance from "../../lib/Models/Definition/createStratumInstance";
configure({
  enforceActions: "always",
  computedRequiresReaction: true
});
let InnerTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Foo",
  description: "Foo"
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Bar",
  description: "Bar"
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Baz",
  description: "Baz"
}), _class = class InnerTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "foo", _descriptor, this);
    _initializerDefineProperty(this, "bar", _descriptor2, this);
    _initializerDefineProperty(this, "baz", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "foo", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bar", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "baz", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let OuterTraits = (_dec4 = objectTrait({
  type: InnerTraits,
  name: "Inner",
  description: "Inner"
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Other",
  description: "Other"
}), _class2 = class OuterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "inner", _descriptor4, this);
    _initializerDefineProperty(this, "other", _descriptor5, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "inner", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "other", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
class TestModel extends CreateModel(OuterTraits) {}
describe("objectTrait", function () {
  it("returns an empty model if all strata are undefined", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    model.strata.set("definition", createStratumInstance(OuterTraits));
    model.strata.set("user", createStratumInstance(OuterTraits));
    expect(model.inner).toBeDefined();
  });
  it("combines values from different strata", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = createStratumInstance(InnerTraits);
    definition.inner.foo = "a";
    definition.inner.bar = 1;
    user.inner = createStratumInstance(InnerTraits);
    user.inner.bar = 2;
    user.inner.baz = true;
    expect(model.inner).toBeDefined();
    if (model.inner !== undefined) {
      expect(model.inner.foo).toEqual("a");
      expect(model.inner.bar).toEqual(2);
      expect(model.inner.baz).toEqual(true);
    }
  });
  it("updates to reflect properties added after evaluation", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = createStratumInstance(InnerTraits);
    definition.inner.foo = "a";
    definition.inner.bar = 1;
    user.inner = createStratumInstance(InnerTraits);
    expect(model.inner).toBeDefined();
    if (model.inner !== undefined) {
      expect(model.inner.foo).toEqual("a");
      expect(model.inner.bar).toEqual(1);
      expect(model.inner.baz).toBeUndefined();
      runInAction(() => {
        expect(user.inner).toBeDefined();
        if (user.inner !== undefined) {
          user.inner.bar = 2;
        }
      });
      expect(model.inner.bar).toEqual(2);
    }
  });
  it("updates to reflect new strata added after evaluation", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const inner = model.inner;
    inner.setTrait("user", "bar", 1);
    expect(inner.bar).toBe(1);
    expect(inner.baz).toBeUndefined();
    model.setTrait("user", "other", "test");
    expect(inner.bar).toBe(1);
    expect(inner.baz).toBeUndefined();
    model.setTrait("definition", "inner", createStratumInstance(InnerTraits, {
      bar: 2,
      baz: true
    }));
    expect(inner.bar).toBe(1);
    expect(inner.baz).toBe(true);
    expect(model.inner.bar).toBe(1);
    expect(model.inner.baz).toBe(true);
  });
});